import React from 'react'
import "./Util.css"
const Util = () => {
  return (
    <div className=' flex flex-col w-full h-[90vh] relative'>
        <div className=' w-full h-auto flex flex-col container mx-auto mt-10'>
            <h2  className=' text-white text-5xl font-bold w-full text-center'>Utility</h2>
            <div className=' w-full h-auto flex flex-row mt-20 '>
                <div className=' w-1/2 flex flex-col h-auto justify-center items-center'>
                    <div className=' w-[350px] border-[1px]  h-[250px] py-4 px-4 flex flex-col util'>
                        <div className=' text-white text-3xl font-bold  w-full h-auto flex'>
                            <h3>Brick & Mortar</h3>
                        </div>
                    </div>
                    
                </div>
                <div className=' w-1/2 h-auto flex flex-col'>
                        <div className=' border-[1px] w-[200px] h-auto flex mt-12 ut-img'>
                            <img src={require("../../assets/images/slide.gif")} className=' w-[200px] h-auto' alt='logo'/>
                        </div>
                </div>
            </div>
            <div className=' w-full h-auto flex flex-row mt-20 '>
                <div className=' w-1/2 flex flex-col h-auto justify-center items-center'>
                    <div className=' w-[350px] border-[1px]  h-[250px] py-4 px-4 flex flex-col util'>
                        <div className=' text-white text-3xl font-bold  w-full h-auto flex'>
                            <h3>Beverage</h3>
                        </div>
                    </div>
                    
                </div>
                <div className=' w-1/2 h-auto flex flex-col'>
                        <div className=' border-[1px] w-[200px] h-auto flex mt-12 ut-img'>
                            <img src={require("../../assets/images/slide.gif")} className=' w-[200px] h-auto' alt='logo'/>
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Util